import React from "react";

import PromotionTable from "../../components/Tables/Promotion/Promotion";

const Promotion = () => <PromotionTable />;

export default Promotion;
